import { render } from "./InteractiveImage.vue?vue&type=template&id=0f5eebb8&scoped=true"
import script from "./InteractiveImage.vue?vue&type=script&lang=js"
export * from "./InteractiveImage.vue?vue&type=script&lang=js"

import "./InteractiveImage.vue?vue&type=style&index=0&id=0f5eebb8&scoped=true&lang=scss"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5eebb8"]])

export default __exports__